(() => {
  const bar = document.getElementById('antar-sticky-atc');
  const info = document.querySelector('.product__info-container');
  if (!bar || !info || bar.dataset.initialized) return;
  bar.dataset.initialized = 'true';
  const button = bar.querySelector('.antar-sticky__btn');
  const title = bar.querySelector('.antar-sticky__title');
  const price = bar.querySelector('.antar-sticky__price');
  let observedButton;
  const unavailable = (real) => !real || real.disabled || real.getAttribute('aria-disabled') === 'true';
  function syncVisibility() {
    // Do not cover the photo on arrival: show only after scrolling past the buy button.
    const show = !!observedButton && observedButton.getBoundingClientRect().bottom <= 0;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', String(!show));
    bar.inert = !show;
  }
  const visibility = 'IntersectionObserver' in window ? new IntersectionObserver(syncVisibility) : null;
  // A fast jump can skip the viewport entirely without an intersection change.
  let scrollPending = false;
  function scheduleVisibility() {
    if (scrollPending) return;
    scrollPending = true;
    requestAnimationFrame(() => { scrollPending = false; syncVisibility(); });
  }
  window.addEventListener('scroll', scheduleVisibility, { passive: true });
  window.addEventListener('resize', scheduleVisibility);
  bar.inert = true;

  function sync() {
    const real = info.querySelector('.product-form__submit');
    const heading = info.querySelector('.product__title h1, h1.product__title, h1');
    // Show the shopper's choice ("Walnut frame · 24 × 36 in"); the product title is already on screen.
    const chosen = [...info.querySelectorAll('variant-selects input[type="radio"]:checked')].map((input) => {
      const label = info.querySelector(`label[for="${input.id}"]`);
      return (label?.querySelector('.antar-lbl-short')?.textContent || input.value || '').trim();
    }).concat([...info.querySelectorAll('variant-selects select')].map((s) => s.value)).filter(Boolean);
    title.textContent = chosen.length ? chosen.join(' · ') : (heading?.textContent.trim() || '');
    // Dawn replaces the .price element on variant changes. Always re-query it.
    const current = info.querySelector('.price');
    const item = current?.querySelector(current.classList.contains('price--on-sale')
      ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular:not(s)');
    price.textContent = current && !current.closest('.hidden') ? (item?.textContent || '').replace(/\s+/g, ' ').trim() : '';
    button.disabled = unavailable(real);
    button.setAttribute('aria-disabled', String(button.disabled));
    button.setAttribute('aria-busy', String(real?.classList.contains('loading') || false));
    button.textContent = real?.querySelector('span')?.textContent.trim() || window.variantStrings?.unavailable || 'Unavailable';
    button.setAttribute('aria-label', button.textContent);
    if (real !== observedButton) {
      visibility?.disconnect();
      observedButton = real;
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      bar.inert = true;
      if (real) visibility?.observe(real);
      syncVisibility();
    }
  }
  button.addEventListener('click', () => {
    const real = info.querySelector('.product-form__submit');
    // Recheck at click time, including the interval before the observer runs.
    if (unavailable(real)) return;
    const form = real.closest('form');
    if (form?.requestSubmit) form.requestSubmit(real);
    else real.click();
  });
  sync();
  info.addEventListener('change', sync);
  if ('MutationObserver' in window) {
    new MutationObserver(sync).observe(info, {
      childList: true, subtree: true, characterData: true, attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });
  }
})();
